import { useId, useState } from "react";
import { Link } from "react-router-dom";
import { isNewsletterEnabled, subscribe } from "../lib/newsletter";

const DEFAULT_HEADLINE =
  "PDF e tip vanity: 1 mail ogni tanto, tool onesti senza claim medici";
const DEFAULT_LEAD = "routine-vanity";

export default function NewsletterForm({
  headline = DEFAULT_HEADLINE,
  leadMagnet = DEFAULT_LEAD,
  source = "footer",
  className = "",
}) {
  const statusId = useId();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState("idle");
  const [message, setMessage] = useState("");

  if (!isNewsletterEnabled()) return null;

  const hasError = status === "error" || status === "duplicate";

  async function onSubmit(e) {
    e.preventDefault();
    if (!consent) {
      setStatus("error");
      setMessage("Per iscriverti serve il consenso all’informativa privacy.");
      return;
    }
    setStatus("loading");
    setMessage("");
    try {
      await subscribe({ email, consent, leadMagnet, source });
      setStatus("ok");
      setMessage("Iscrizione registrata. Grazie — a presto in inbox.");
      setEmail("");
      setConsent(false);
    } catch (err) {
      if (err.status === 409) {
        setStatus("duplicate");
        setMessage("Questo indirizzo è già iscritto.");
      } else {
        setStatus("error");
        setMessage(err.message || "Qualcosa è andato storto. Riprova più tardi.");
      }
    }
  }

  return (
    <div
      className={className}
      data-testid="newsletter-form"
      aria-labelledby="newsletter-heading"
    >
      <p id="newsletter-heading" className="label-eyebrow text-white/60 mb-3">
        Newsletter
      </p>
      <p className="text-sm text-white/80 leading-relaxed mb-4 max-w-sm">{headline}</p>
      <form onSubmit={onSubmit} className="space-y-3" noValidate>
        <label className="block">
          <span className="sr-only">Email</span>
          <input
            type="email"
            name="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="la tua email"
            disabled={status === "loading"}
            aria-invalid={hasError || undefined}
            aria-describedby={message ? statusId : undefined}
            className="w-full min-h-11 px-3 bg-white/5 border border-white/20 text-white text-sm placeholder:text-white/60 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
            data-testid="newsletter-email"
          />
        </label>
        <label className="flex gap-3 items-start text-xs text-white/60 leading-relaxed cursor-pointer">
          <input
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            disabled={status === "loading"}
            className="mt-0.5 h-4 w-4 accent-pink-soft"
            data-testid="newsletter-consent"
          />
          <span>
            Ho letto l&apos;
            <Link to="/privacy" className="link-underline text-white/80">
              Informativa privacy
            </Link>{" "}
            e acconsento a ricevere email editoriali (anche con link commerciali; vedi{" "}
            <Link to="/disclosure" className="link-underline text-white/80">
              Trasparenza
            </Link>
            ). Posso revocare in qualsiasi momento.
          </span>
        </label>
        <button
          type="submit"
          disabled={status === "loading"}
          className="min-h-11 px-4 text-sm bg-white text-ink hover:bg-white/90 disabled:opacity-60"
          data-testid="newsletter-submit"
        >
          {status === "loading" ? "Invio…" : "Iscriviti"}
        </button>
        {message ? (
          <p
            id={statusId}
            role="status"
            className={`text-xs ${hasError ? "text-white/90" : "text-white/70"}`}
            data-testid="newsletter-status"
          >
            {message}
          </p>
        ) : null}
      </form>
    </div>
  );
}
